import { UPDATE_PRIVACY_SETTINGS } from './Constants';

export const PrivacySettingsAction = data => {
    return {
        type: UPDATE_PRIVACY_SETTINGS,
        payload: data,
    };
};
